export default __webpack_public_path__ + "static/media/ramazan.2b96a146.jpg";